// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__35B8p","resendInfoText":"OnGoingPaymentBox_resendInfoText__Y_234"};